/***************************************************************************
 * The contents of this file were generated with Amplify Studio.           *
 * Please refrain from making any modifications to this file.              *
 * Any changes to this file will be overwritten when running amplify pull. *
 **************************************************************************/

/* eslint-disable */
import * as React from "react";
import {
  getOverrideProps,
  useDataStoreCreateAction,
  useNavigateAction,
} from "@aws-amplify/ui-react/internal";
import { Qanswer } from "../models";
import { schema } from "../models/schema";
import { Flex, Icon, Text, View } from "@aws-amplify/ui-react";
export default function Footer(props) {
  const { test, overrides, ...rest } = props;
  const groupOneOnClick = useNavigateAction({ type: "url", url: "/" });
  const groupTwoOnClick = useNavigateAction({
    type: "url",
    url: "ContentsList",
  });
  const groupThreeOnClick = useNavigateAction({ type: "url", url: "" });
  const rectangleOneThreeNineZeroFourTwoThreeOneTwoOnClick =
    useDataStoreCreateAction({
      fields: { PageNo: "1", AnsNo: "1" },
      model: Qanswer,
      schema: schema,
    });
  const vectorThreeNineOneFourTwoSevenFourFiveOnClick = useNavigateAction({
    type: "url",
    url: "/CommunityList",
  });
  const vectorThreeNineOneFourTwoSevenFourSixOnClick = useNavigateAction({
    type: "url",
    url: "/ContentsUp",
  });
  const groupFiveOnClick = useNavigateAction({ type: "url", url: "MyPage" });
  return (
    <Flex
      gap="40px"
      direction="row"
      width="664px"
      height="101px"
      justifyContent="center"
      alignItems="center"
      overflow="hidden"
      position="relative"
      padding="41px 10px 41px 10px"
      backgroundColor="rgba(255,255,255,1)"
      {...getOverrideProps(overrides, "Footer")}
      {...rest}
    >
      <Flex
        padding="0px 0px 0px 0px"
        width="68px"
        height="84px"
        display="block"
        gap="unset"
        alignItems="unset"
        justifyContent="unset"
        shrink="0"
        position="relative"
        onClick={() => {
          groupOneOnClick();
        }}
        {...getOverrideProps(overrides, "Group 1")}
      >
        <View
          width="68px"
          height="84px"
          display="block"
          gap="unset"
          alignItems="unset"
          justifyContent="unset"
          position="absolute"
          top="0px"
          left="0px"
          padding="0px 0px 0px 0px"
          backgroundColor="rgba(255,255,255,1)"
          {...getOverrideProps(overrides, "Rectangle 139042300")}
        ></View>
        <Text
          fontFamily="Inter"
          fontSize="12px"
          fontWeight="500"
          color="rgba(209,112,145,1)"
          lineHeight="14.522727012634277px"
          textAlign="center"
          display="block"
          direction="column"
          justifyContent="unset"
          width="unset"
          height="unset"
          gap="unset"
          alignItems="unset"
          position="absolute"
          top="64px"
          left="16px"
          padding="0px 0px 0px 0px"
          whiteSpace="pre-wrap"
          children="ホーム"
          {...getOverrideProps(overrides, "\u30DB\u30FC\u30E0")}
        ></Text>
        <Icon
          width="40px"
          height="39.02px"
          viewBox={{ minX: 0, minY: 0, width: 40, height: 39.024383544921875 }}
          paths={[
            {
              d: "M0 39.0244L0 13.0081L20 0L40 13.0081L40 39.0244L25 39.0244L25 23.8482L15 23.8482L15 39.0244L0 39.0244Z",
              fill: "rgba(209,112,145,1)",
              fillRule: "nonzero",
            },
          ]}
          display="block"
          gap="unset"
          alignItems="unset"
          justifyContent="unset"
          position="absolute"
          top="18.45%"
          bottom="35.09%"
          left="22.79%"
          right="18.38%"
          {...getOverrideProps(overrides, "Vector39142742")}
        ></Icon>
      </Flex>
      <Flex
        padding="0px 0px 0px 0px"
        width="68px"
        height="84px"
        display="block"
        gap="unset"
        alignItems="unset"
        justifyContent="unset"
        shrink="0"
        position="relative"
        onClick={() => {
          groupTwoOnClick();
        }}
        {...getOverrideProps(overrides, "Group 2")}
      >
        <View
          width="68px"
          height="84px"
          display="block"
          gap="unset"
          alignItems="unset"
          justifyContent="unset"
          position="absolute"
          top="0px"
          left="0px"
          padding="0px 0px 0px 0px"
          backgroundColor="rgba(255,255,255,1)"
          {...getOverrideProps(overrides, "Rectangle 139042306")}
        ></View>
        <Text
          fontFamily="Inter"
          fontSize="12px"
          fontWeight="500"
          color="rgba(209,112,145,1)"
          lineHeight="14.522727012634277px"
          textAlign="center"
          display="block"
          direction="column"
          justifyContent="unset"
          width="unset"
          height="unset"
          gap="unset"
          alignItems="unset"
          position="absolute"
          top="64px"
          left="10px"
          padding="0px 0px 0px 0px"
          whiteSpace="pre-wrap"
          children="みつける"
          {...getOverrideProps(overrides, "\u307F\u3064\u3051\u308B")}
        ></Text>
        <Icon
          width="40px"
          height="40px"
          viewBox={{ minX: 0, minY: 0, width: 39.99805450439453, height: 40 }}
          paths={[
            {
              d: "M18.0091 6.74094e-08C15.1321 0.00031159 12.297 0.689826 9.7412 2.01082C7.18539 3.33182 4.98321 5.24586 3.31902 7.59271C1.65483 9.93956 0.577062 12.6509 0.175928 15.4998C-0.225205 18.3488 0.0619735 21.2523 1.01342 23.9675C1.96487 26.6826 3.55291 29.1303 5.64459 31.1057C7.73627 33.081 10.2707 34.5266 13.0358 35.3213C15.8009 36.1161 18.7161 36.2368 21.5374 35.6735C24.3588 35.1103 27.0041 33.8793 29.252 32.0837L36.6065 39.4382C36.984 39.8028 37.4895 40.0045 38.0142 39.9999C38.5389 39.9954 39.0409 39.7849 39.4119 39.4139C39.783 39.0428 39.9934 38.5409 39.998 38.0162C40.0025 37.4914 39.8008 36.9859 39.4363 36.6085L32.0818 29.254C34.1991 26.6041 35.5251 23.4102 35.9071 20.0399C36.2892 16.6696 35.7118 13.2599 34.2414 10.2033C32.771 7.14665 30.4674 4.56736 27.5957 2.76228C24.724 0.957205 21.401 -0.000293335 18.0091 6.74094e-08ZM6.00174 18.0111C6.00174 16.4342 6.31232 14.8728 6.91575 13.416C7.51918 11.9592 8.40363 10.6356 9.51862 9.52057C10.6336 8.40558 11.9573 7.52112 13.4141 6.9177C14.8709 6.31427 16.4323 6.00369 18.0091 6.00369C19.586 6.00369 21.1473 6.31427 22.6041 6.9177C24.0609 7.52112 25.3846 8.40558 26.4996 9.52057C27.6146 10.6356 28.4991 11.9592 29.1025 13.416C29.7059 14.8728 30.0165 16.4342 30.0165 18.0111C30.0165 21.1956 28.7514 24.2497 26.4996 26.5016C24.2478 28.7534 21.1937 30.0184 18.0091 30.0184C14.8246 30.0184 11.7704 28.7534 9.51862 26.5016C7.2668 24.2497 6.00174 21.1956 6.00174 18.0111Z",
              fill: "rgba(209,112,145,1)",
              fillRule: "evenodd",
            },
          ]}
          display="block"
          gap="unset"
          alignItems="unset"
          justifyContent="unset"
          position="absolute"
          top="18.75%"
          bottom="33.63%"
          left="17.41%"
          right="23.77%"
          {...getOverrideProps(overrides, "Vector39142744")}
        ></Icon>
      </Flex>
      <Flex
        padding="0px 0px 0px 0px"
        width="72px"
        height="84px"
        display="block"
        gap="unset"
        alignItems="unset"
        justifyContent="unset"
        shrink="0"
        position="relative"
        onClick={() => {
          groupThreeOnClick();
        }}
        {...getOverrideProps(overrides, "Group 3")}
      >
        <View
          width="68px"
          height="84px"
          display="block"
          gap="unset"
          alignItems="unset"
          justifyContent="unset"
          position="absolute"
          top="0px"
          left="2px"
          padding="0px 0px 0px 0px"
          backgroundColor="rgba(255,255,255,1)"
          onClick={() => {
            rectangleOneThreeNineZeroFourTwoThreeOneTwoOnClick();
          }}
          {...getOverrideProps(overrides, "Rectangle 139042312")}
        ></View>
        <Text
          fontFamily="Inter"
          fontSize="12px"
          fontWeight="500"
          color="rgba(209,112,145,1)"
          lineHeight="14.522727012634277px"
          textAlign="center"
          display="block"
          direction="column"
          justifyContent="unset"
          width="unset"
          height="unset"
          gap="unset"
          alignItems="unset"
          position="absolute"
          top="64px"
          left="0px"
          padding="0px 0px 0px 0px"
          whiteSpace="pre-wrap"
          children="コミュニティ"
          {...getOverrideProps(
            overrides,
            "\u30B3\u30DF\u30E5\u30CB\u30C6\u30A3"
          )}
        ></Text>
        <Icon
          width="46.69px"
          height="40px"
          viewBox={{ minX: 0, minY: 0, width: 46.6852912902832, height: 40 }}
          paths={[
            {
              d: "M23.3426 1.48089e-15C22.4677 -1.30378e-08 21.6013 0.172335 20.793 0.507164C19.9846 0.841994 19.2501 1.33276 18.6314 1.95145C18.0128 2.57013 17.522 3.30462 17.1872 4.11297C16.8523 4.92132 16.68 5.7877 16.68 6.66266C16.68 7.53761 16.8523 8.404 17.1872 9.21235C17.522 10.0207 18.0128 10.7552 18.6314 11.3739C19.2501 11.9926 19.9846 12.4833 20.793 12.8182C21.6013 13.153 22.4677 13.3253 23.3426 13.3253C25.1097 13.3253 26.8044 12.6234 28.0539 11.3739C29.3033 10.1244 30.0053 8.4297 30.0053 6.66266C30.0053 4.89561 29.3033 3.20094 28.0539 1.95145C26.8044 0.701956 25.1097 2.96178e-15 23.3426 1.48089e-15ZM38.3486 3.32799C37.022 3.32799 35.7497 3.85499 34.8117 4.79304C33.8736 5.7311 33.3466 7.00338 33.3466 8.32999C33.3466 9.6566 33.8736 10.9289 34.8117 11.8669C35.7497 12.805 37.022 13.332 38.3486 13.332C39.6752 13.332 40.9475 12.805 41.8856 11.8669C42.8236 10.9289 43.3506 9.6566 43.3506 8.32999C43.3506 7.00338 42.8236 5.7311 41.8856 4.79304C40.9475 3.85499 39.6752 3.32799 38.3486 3.32799ZM8.33666 3.32799C7.01005 3.32799 5.73777 3.85499 4.79971 4.79304C3.86166 5.7311 3.33466 7.00338 3.33466 8.32999C3.33466 9.6566 3.86166 10.9289 4.79971 11.8669C5.73777 12.805 7.01005 13.332 8.33666 13.332C9.66327 13.332 10.9355 12.805 11.8736 11.8669C12.8117 10.9289 13.3387 9.6566 13.3387 8.32999C13.3387 7.00338 12.8117 5.7311 11.8736 4.79304C10.9355 3.85499 9.66327 3.32799 8.33666 3.32799ZM13.3387 19.978C13.3448 19.0976 13.6989 18.2554 14.3236 17.6351C14.9483 17.0148 15.7929 16.6666 16.6733 16.6666L30.012 16.6666C30.8964 16.6666 31.7446 17.018 32.3699 17.6434C32.9953 18.2687 33.3466 19.1169 33.3466 20.0013L33.3466 30.0053C33.3464 31.0548 33.1821 32.0978 32.8598 33.0965C32.1214 35.3598 30.6003 37.2857 28.5698 38.5284C26.5392 39.7711 24.1321 40.2492 21.7808 39.8768C19.4294 39.5045 17.2878 38.3061 15.7406 36.4968C14.1933 34.6876 13.3417 32.386 13.3387 30.0053L13.3387 19.978ZM10.004 20.0013C10.004 18.7842 10.3275 17.647 10.8977 16.6666L3.33466 16.6666C2.45026 16.6666 1.60207 17.018 0.976701 17.6434C0.35133 18.2687 4.61562e-07 19.1169 4.61562e-07 20.0013L4.61562e-07 28.338C-0.000453674 29.7029 0.33422 31.047 0.974632 32.2523C1.61504 33.4576 2.5416 34.4873 3.67294 35.2509C4.80428 36.0144 6.10578 36.4885 7.46317 36.6315C8.82055 36.7745 10.1923 36.5821 11.4579 36.0711C10.4981 34.1922 9.99972 32.1118 10.004 30.002L10.004 20.0013ZM36.6813 20.0013L36.6813 30.0053C36.6813 32.1895 36.1578 34.2503 35.2274 36.0711C36.493 36.5821 37.8647 36.7745 39.2221 36.6315C40.5795 36.4885 41.881 36.0144 43.0124 35.2509C44.1437 34.4873 45.0702 33.4576 45.7107 32.2523C46.3511 31.047 46.6857 29.7029 46.6853 28.338L46.6853 20.0013C46.6853 19.1169 46.334 18.2687 45.7086 17.6434C45.0832 17.018 44.235 16.6666 43.3506 16.6666L35.7876 16.6666C36.3545 17.647 36.6813 18.7842 36.6813 20.0013Z",
              fill: "rgba(209,112,145,1)",
              fillRule: "nonzero",
            },
          ]}
          display="block"
          gap="unset"
          alignItems="unset"
          justifyContent="unset"
          position="absolute"
          top="18.45%"
          bottom="33.93%"
          left="18.75%"
          right="16.41%"
          onClick={() => {
            vectorThreeNineOneFourTwoSevenFourFiveOnClick();
          }}
          {...getOverrideProps(overrides, "Vector39142745")}
        ></Icon>
      </Flex>
      <Flex
        padding="0px 0px 0px 0px"
        width="68px"
        height="84px"
        display="block"
        gap="unset"
        alignItems="unset"
        justifyContent="unset"
        shrink="0"
        position="relative"
        {...getOverrideProps(overrides, "Group 4")}
      >
        <View
          width="68px"
          height="84px"
          display="block"
          gap="unset"
          alignItems="unset"
          justifyContent="unset"
          position="absolute"
          top="0px"
          left="0px"
          padding="0px 0px 0px 0px"
          backgroundColor="rgba(255,255,255,1)"
          {...getOverrideProps(overrides, "Rectangle 139042318")}
        ></View>
        <Text
          fontFamily="Inter"
          fontSize="12px"
          fontWeight="500"
          color="rgba(209,112,145,1)"
          lineHeight="14.522727012634277px"
          textAlign="center"
          display="block"
          direction="column"
          justifyContent="unset"
          width="unset"
          height="unset"
          gap="unset"
          alignItems="unset"
          position="absolute"
          top="64px"
          left="10px"
          padding="0px 0px 0px 0px"
          whiteSpace="pre-wrap"
          children="投稿する"
          {...getOverrideProps(overrides, "\u6295\u7A3F\u3059\u308B")}
        ></Text>
        <Icon
          width="40px"
          height="40px"
          viewBox={{ minX: 0, minY: 0, width: 40, height: 40 }}
          paths={[
            {
              d: "M12.2826 37.2172L32.2831 17.2167L22.7833 7.71689L2.7828 27.7174C2.50746 27.993 2.31187 28.3381 2.21677 28.716L0 40L11.2819 37.7832C11.6607 37.6885 12.0072 37.4927 12.2826 37.2172ZM38.7397 10.7601C39.5467 9.95292 40 8.85827 40 7.71689C40 6.57552 39.5467 5.48087 38.7397 4.67367L35.3263 1.26027C34.5191 0.453321 33.4245 0 32.2831 0C31.1417 0 30.0471 0.453321 29.2399 1.26027L25.8265 4.67367L35.3263 14.1735L38.7397 10.7601Z",
              fill: "rgba(209,112,145,1)",
              fillRule: "nonzero",
            },
          ]}
          display="block"
          gap="unset"
          alignItems="unset"
          justifyContent="unset"
          position="absolute"
          top="18.75%"
          bottom="33.63%"
          left="17.4%"
          right="23.77%"
          onClick={() => {
            vectorThreeNineOneFourTwoSevenFourSixOnClick();
          }}
          {...getOverrideProps(overrides, "Vector39142746")}
        ></Icon>
      </Flex>
      <Flex
        padding="0px 0px 0px 0px"
        width="72px"
        height="84px"
        display="block"
        gap="unset"
        alignItems="unset"
        justifyContent="unset"
        shrink="0"
        position="relative"
        onClick={() => {
          groupFiveOnClick();
        }}
        {...getOverrideProps(overrides, "Group 5")}
      >
        <View
          width="68px"
          height="84px"
          display="block"
          gap="unset"
          alignItems="unset"
          justifyContent="unset"
          position="absolute"
          top="0px"
          left="2px"
          padding="0px 0px 0px 0px"
          backgroundColor="rgba(255,255,255,1)"
          {...getOverrideProps(overrides, "Rectangle 139042324")}
        ></View>
        <Text
          fontFamily="Inter"
          fontSize="12px"
          fontWeight="500"
          color="rgba(209,112,145,1)"
          lineHeight="14.522727012634277px"
          textAlign="center"
          display="block"
          direction="column"
          justifyContent="unset"
          width="unset"
          height="unset"
          gap="unset"
          alignItems="unset"
          position="absolute"
          top="64px"
          left="0px"
          padding="0px 0px 0px 0px"
          whiteSpace="pre-wrap"
          children="プロフィール"
          {...getOverrideProps(
            overrides,
            "\u30D7\u30ED\u30D5\u30A3\u30FC\u30EB"
          )}
        ></Text>
        <Icon
          width="30.48px"
          height="40px"
          viewBox={{ minX: 0, minY: 0, width: 30.4761962890625, height: 40 }}
          paths={[
            {
              d: "M0 40C0 35.9586 1.60544 32.0827 4.46313 29.225C7.32083 26.3673 11.1967 24.7619 15.2381 24.7619C19.2795 24.7619 23.1554 26.3673 26.0131 29.225C28.8708 32.0827 30.4762 35.9586 30.4762 40L0 40ZM15.2381 22.8571C8.92381 22.8571 3.80952 17.7429 3.80952 11.4286C3.80952 5.11429 8.92381 0 15.2381 0C21.5524 0 26.6667 5.11429 26.6667 11.4286C26.6667 17.7429 21.5524 22.8571 15.2381 22.8571Z",
              fill: "rgba(209,112,145,1)",
              fillRule: "nonzero",
            },
          ]}
          display="block"
          gap="unset"
          alignItems="unset"
          justifyContent="unset"
          position="absolute"
          top="14.88%"
          bottom="37.5%"
          left="29.86%"
          right="27.81%"
          {...getOverrideProps(overrides, "Vector39142747")}
        ></Icon>
      </Flex>
    </Flex>
  );
}
